<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>放映厅购买列表</el-breadcrumb-item>
        </el-breadcrumb>

        <!--搜素 -->
        <el-form :inline="true" style="margin-top: 20px;">
            <el-form-item>
                <el-input size="small" v-model="screenName" placeholder="请输入放映厅名称"></el-input>
            </el-form-item>
            <el-form-item>
                <el-input size="small" v-model="mobile" placeholder="请输入购买人手机号"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="chongzhi">重置</el-button>
            </el-form-item>
        </el-form>

        <!-- 列表 -->
        <el-table size="small" :data="BuyData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中"
            style="width: 100%;" v-horizontal-scroll>
            <el-table-column align="center" sortable type="index" label="序号"></el-table-column>
            <el-table-column align="center" sortable prop="nickName" label="购买人昵称" width="120"></el-table-column>
            <el-table-column align="center" sortable prop="mobile" label="购买人手机号" width="120"></el-table-column>
            <el-table-column align="center" sortable prop="avatar" label="购买人头像" width="120">
                <template slot-scope="scope">
                    <el-image v-if="scope.row.avatar" style="width: 40px;height: 40px;" :src="scope.row.avatar"
                        :preview-src-list="[scope.row.avatar]" />
                    <div v-if="scope.row.avatar == null">没有头像</div>
                </template>
            </el-table-column>
            <el-table-column align="center" sortable prop="name" label="放映厅名称" width="120"></el-table-column>
            <el-table-column align="center" sortable prop="image" label="封面图" width="120">
                <template slot-scope="scope">
                    <el-image v-if="scope.row.image" style="width: 90px;height: 90px;" :src="scope.row.image"
                        :preview-src-list="[scope.row.image]" />
                    <div v-if="scope.row.image == null">没有图片</div>
                </template>
            </el-table-column>
            <el-table-column align="center" sortable prop="categoryName" label="分类名" width="120"></el-table-column>
            <el-table-column align="center" sortable prop="money" label="购买金额" width="120"></el-table-column>
            <el-table-column align="center" sortable prop="buyTime" label="购买时间" width="160">
                <template slot-scope="scope">
                    <div v-if="scope.row.buyTime">{{ transformDate(scope.row.buyTime) }}</div>
                </template>
            </el-table-column>
            <el-table-column align="center" sortable prop="score" label="评分" width="100"></el-table-column>
            <el-table-column align="center" sortable prop="episodes" label="集数" width="100">
                <template slot-scope="scope">
                    <div v-if="scope.row.episodes">{{ '第' + scope.row.episodes + '集' }}</div>
                </template>
            </el-table-column>
            <el-table-column align="center" sortable prop="description" label="描述" width="150"></el-table-column>
            <el-table-column align="center" sortable prop="createTime" label="创建时间" width="160">
                <template slot-scope="scope">
                    <div v-if="scope.row.createTime">{{ transformDate(scope.row.createTime) }}</div>
                </template>
            </el-table-column>
        </el-table>

        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    </div>
</template>

<script>
import Pagination from '../../components/Pagination'
import { getScreenBuyList } from '../../api/userMG'
export default {
    data() {
        return {
            BuyData: [],
            mobile: '',
            screenName: '',
            // 分页参数
            pageparm: {
                currentPage: 1,
                pageSize: 20,
                total: 10
            },
            loading: false
        }
    },
    // 注册组件
    components: {
        Pagination
    },
    created() {
        this.getShow(1);
    },
    methods: {
        // 分页插件事件
        callFather(parm) {
            this.pageparm.page = parm.currentPage
            this.getdata(parm.currentPage)
        },
        // 搜索事件
        search() {
            this.getShow(1)
        },
        // 重置数据
        chongzhi() {
            this.mobile = ''
            this.screenName = ''
            this.getShow(1)
        },
        // 获取列表数据
        getShow(page) {
            this.loading = true;
            let data = {
                mobile: this.mobile,
                screenName: this.screenName,
                page: (page - 1) * 20
            }
            getScreenBuyList(data).then((res) => {
                this.loading = false;
                if (res.code == 200) {
                    this.BuyData = res.data.list;
                    this.pageparm.currentPage = page;
                    this.pageparm.total = res.data.count;
                    return;
                } else {
                    this.$Message({
                        type: "info",
                        message: res.msg
                    })
                }
            })
        }
    }
}
</script>

<style></style>


// WEBPACK FOOTER //
// src/views/show/RoomBuy.vue